import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MAX_ROOMS_ALLOWED, BUSINESS_BOOKER_USER_ROLES } from '@whitbread-eos/api';
import { Notification, Button } from '@whitbread-eos/atoms/ui';
import { RolesRequired, useTranslation, formatIBAssetsUrl } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { Room } from './Room';
const RoomOccupancyDropdown = ({ rooms, formLabels, updateRoom, addRoomIcon, addRoom, removeRoom, icons, userRole, toggleDropdown })=>{
    const { t } = useTranslation();
    const roomsLength = Object.keys(rooms).length;
    return /*#__PURE__*/ _jsxs("div", {
        className: dropdownStyle,
        "data-testid": "RoomOccupancyDropdown-Container",
        children: [
            !!roomsLength && Object.entries(rooms).map(([roomId, roomDetails], id)=>{
                return /*#__PURE__*/ _jsx(Room, {
                    roomNumber: id + 1,
                    roomId: roomId,
                    room: roomDetails,
                    updateRoom: updateRoom,
                    formLabels: formLabels,
                    icons: icons,
                    hasSeparator: id + 1 !== roomsLength,
                    removeRoom: removeRoom,
                    roomsCount: roomsLength
                }, roomId);
            }),
            /*#__PURE__*/ _jsx(RolesRequired, {
                userRole: userRole,
                requiredRoles: [
                    BUSINESS_BOOKER_USER_ROLES.SUPER,
                    BUSINESS_BOOKER_USER_ROLES.BOOKER
                ],
                children: roomsLength < MAX_ROOMS_ALLOWED ? /*#__PURE__*/ _jsxs("button", {
                    "data-testid": "IB-Add-Room-Button",
                    className: addRoomButtonStyle,
                    onClick: ()=>addRoom(),
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            className: addRoomIconStyle,
                            src: addRoomIcon,
                            width: 40,
                            height: 40,
                            alt: 'Add Room Icon'
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: t('content.global.addRoom')
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(Notification, {
                    type: "warning",
                    icon: formatIBAssetsUrl(icons['icon.notification.alert']),
                    title: 'Unable to add more rooms',
                    message: 'For a group booking of five to nine rooms, call us on 0333 003 8101. To book 10 rooms or over, please email group.enquiries@whitbread.com.'
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                "data-testid": "IB-Room-Occupancy-Done-Button",
                onClick: toggleDropdown,
                variant: "alternativeDefault",
                children: t('content.global.done')
            })
        ]
    });
};
export default RoomOccupancyDropdown;
const dropdownStyle = 'flex flex-col gap-6';
const addRoomButtonStyle = 'flex items-center gap-4 cursor-pointer';
const addRoomIconStyle = 'w-10 h-10';
